const packs = [
  {
    hat: 'Mentoria',
    name: 'Na Rota do Mercado Financeiro',
    description: `
      1º Ciclo - Reset - 3 semanas<br />
      2º Ciclo - Mercado Financeiro - 3 semanas<br />
      3º Ciclo - Você na Rota do Mercado - 2 semanas<br />
      <br />
      <strong>Convidados especiais:</strong><br />
      • Guilherme Benchimol - Fundador da XP Inc.<br />
      • Marcos Boschetti - Fundador e CEO da Nelogica<br />
      • Caio Peres - Head de Expansão da XP Inc.<br />
      • Victor Mansur - Tesoureiro da XP Inc.<br />
      entre outros.
    `,
    pagamentos: [
      {
        valor: '12x R$ 298,90',
        parcelas: 'ou R$ 2.977,00 a vista',
        link: '',
        label: 'Eu quero',
        descricao: 'Cartão de Crédito, PIX ou Boleto Bancário',
        productId: '500',
      },
    ],
  },
];

export default packs;
